module.exports = __webpack_public_path__ + "static/media/Closed Captions Test_1633270201598.446c1a3e.vtt";